<template>
    <span>
        <criarpost></criarpost>
    </span>
</template>

<script>
import Criarpost from '@/components/Criar-Post';

export default {
    name: 'cadcriarpost',
    components: {
        Criarpost
    }
};
</script>